import React, { useEffect, useState } from 'react';
import { apis, models } from "@vote4dance/judging-sdk";
import { HeaderContainer, BodyContainer } from "../../../../base-react/components/Container";
import { App, Typography, Button, Space, Tooltip } from 'antd';
import { Link, useParams } from "react-router-dom";
import { useCompetition } from "../../../../base-react/hooks/Competition";
import { Localization, _T } from "../../../../base-react/src/Localization";
import { EditOutlined, DeleteOutlined, SaveOutlined, GlobalOutlined, CreditCardOutlined } from '@ant-design/icons';
var CompetitionsSource = models.competitions.CompetitionsSource;
var Api = apis.Api;
import TextEditor from './components/TextEditor';
import { CompetitionStatus } from '@vote4dance/judging-schema';
import dayjs from 'dayjs';
import { Loading } from '../../../../base-react/components/Loading';
import ImageUpload from '../../../../base-react/components/ImageUpload';
import { ButtonConfirm } from '../../../../base-react/components/ButtonConfirm';
import { useUserSettings } from '../../../../base-react/hooks/Storage';
const { Title } = Typography;
const dateFormat = 'YYYY-MM-DD';
export const formatCompetitionDates = (startDate, endDate) => {
    if (!startDate) {
        return '';
    }
    const start = dayjs(startDate, dateFormat);
    const end = endDate ? dayjs(endDate, dateFormat) : undefined;
    if (!end || !end.isValid() || end.isSame(start, 'day')) {
        return start.format('LL');
    }
    return `${start.format('LL')} - ${end.format('LL')}`;
};
const normalizeCompetitionPictureValue = (value) => {
    if (value == null) {
        return undefined;
    }
    const normalizedValue = String(value).trim();
    if (!normalizedValue || normalizedValue === '0' || normalizedValue === 'null') {
        return undefined;
    }
    return normalizedValue;
};
const extractCompetitionPictureValue = (result) => {
    var _a;
    if (result == null) {
        return undefined;
    }
    if (typeof result === 'string' || typeof result === 'number') {
        return normalizeCompetitionPictureValue(result);
    }
    return normalizeCompetitionPictureValue((_a = result.competition_picture) !== null && _a !== void 0 ? _a : result.image_id);
};
export const Overview = () => {
    let { event_id } = useParams();
    const [inputCompetition, event, competitions, loadingCompetition, , canEdit] = useCompetition(event_id);
    const { updateSettings } = useUserSettings();
    const [description, setDescription] = useState('');
    const [hasChanges, sethasChanges] = useState(false);
    const { modal, notification } = App.useApp();
    const normalizedServerPicture = normalizeCompetitionPictureValue(event === null || event === void 0 ? void 0 : event.competition_picture);
    const [pictureValue, setPictureValue] = useState(normalizedServerPicture);
    const [hasPicture, setHasPicture] = useState(Boolean(normalizedServerPicture));
    useEffect(() => {
        if (event && event.competition_long_description) {
            setDescription(event.competition_long_description);
        }
    }, [event]);
    useEffect(() => {
        setPictureValue(normalizedServerPicture);
        setHasPicture(Boolean(normalizedServerPicture));
    }, [normalizedServerPicture]);
    const needsBilling = (event === null || event === void 0 ? void 0 : event.competition_billing_reference) == null || (event === null || event === void 0 ? void 0 : event.competition_billing_reference) == "";
    const eventDateLabel = event ? formatCompetitionDates(event.competition_date, event.competition_end_date) : '';
    const onDelete = () => {
        if (competitions && competitions.length > 0) {
            modal.error({
                title: _T('common.error'),
                content: _T('competition.error.deleteChildCompetitions'),
            });
            return;
        }
        const deleteModal = modal.confirm({
            title: _T('common.delete.title', { name: _T('competition.title').toLowerCase() }),
            content: _T('common.delete.content', { name: event === null || event === void 0 ? void 0 : event.competition_name }),
            okButtonProps: { danger: true },
            onOk() {
                deleteModal.update({
                    okButtonProps: { danger: true, loading: true },
                    cancelButtonProps: { disabled: true }
                });
                Api.destroy(`${CompetitionsSource.url}/${event_id}`)
                    .then(() => {
                    window.location.href = '/../../';
                })
                    .catch((err) => {
                    notification.error({
                        message: err.message
                    });
                    deleteModal.update({
                        okButtonProps: { danger: true, loading: false },
                        cancelButtonProps: { disabled: false }
                    });
                });
            }
        });
    };
    const onChangePicture = async (imageData) => {
        var _a;
        if (!(event === null || event === void 0 ? void 0 : event.competition_id)) {
            return;
        }
        setHasPicture(imageData != null);
        if (imageData == null) {
            setPictureValue(undefined);
        }
        try {
            const result = await Api.call(`${CompetitionsSource.url}/${event.competition_id}`, 'set-picture', { picture: imageData });
            const nextPictureValue = extractCompetitionPictureValue(result);
            if (imageData == null) {
                setPictureValue(undefined);
                setHasPicture(false);
                return;
            }
            if (nextPictureValue !== undefined) {
                setPictureValue(nextPictureValue);
            }
        }
        catch (err) {
            setPictureValue(normalizedServerPicture);
            setHasPicture(Boolean(normalizedServerPicture));
            notification.error({
                message: ((_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.message) ? _T(err.response.message) : (err === null || err === void 0 ? void 0 : err.message) || _T('common.error')
            });
        }
    };
    const onSaveDescription = async () => {
        await Api.update(`${CompetitionsSource.url}/${event === null || event === void 0 ? void 0 : event.competition_id}`, {
            ...event,
            competition_long_description: description
        });
    };
    const handleChangeDescription = (value) => {
        sethasChanges(true);
        setDescription(value);
    };
    const onChangeStatus = () => {
        var currentStatus = event === null || event === void 0 ? void 0 : event.competition_status;
        var targetStatus = null;
        if (currentStatus == "private") {
            targetStatus = "public";
            if (!hasPicture) {
                notification.error({
                    message: _T('competition.status.action.image')
                });
                return;
            }
            if (needsBilling) {
                notification.error({
                    message: _T('competition.status.action.billing')
                });
                return;
            }
        }
        else if (currentStatus == "public")
            targetStatus = "closed";
        else if (currentStatus == "closed")
            targetStatus = "private";
        if (targetStatus) {
            const statusModal = modal.confirm({
                title: _T('competition.status.action.title'),
                content: _T('competition.status.action.content', { name: _T('competition.status.' + targetStatus).toLowerCase() }),
                okButtonProps: { danger: true },
                onOk() {
                    statusModal.update({
                        okButtonProps: { danger: true, loading: true },
                        cancelButtonProps: { disabled: true }
                    });
                    Api.call(`${CompetitionsSource.url}/${event_id}`, 'set-status', { competition_status: targetStatus })
                        .then(() => {
                        notification.success({
                            message: _T('competition.status.action.success', { name: targetStatus })
                        });
                    })
                        .catch((err) => {
                        notification.error({
                            message: err.message
                        });
                        statusModal.update({
                            okButtonProps: { danger: true, loading: false },
                            cancelButtonProps: { disabled: false }
                        });
                    });
                }
            });
        }
    };
    const createStatusButton = () => {
        var status = 'publish';
        switch (event === null || event === void 0 ? void 0 : event.competition_status) {
            case CompetitionStatus.Public:
                {
                    status = 'close';
                }
                break;
            case CompetitionStatus.Closed:
                {
                    status = 'hide';
                }
                break;
        }
        const disabledReason = !hasPicture && (event === null || event === void 0 ? void 0 : event.competition_status) === CompetitionStatus.Private
            ? _T('competition.status.action.image')
            : (event === null || event === void 0 ? void 0 : event.competition_status) === CompetitionStatus.Archived
                ? _T('competition.status.archived')
                : undefined;
        const button = React.createElement(Button, { onClick: onChangeStatus, disabled: !!disabledReason, type: "primary" }, _T('competition.status.action.' + status));
        return disabledReason
            ? React.createElement(Tooltip, { title: disabledReason }, button)
            : button;
    };
    const onPublish = async (done) => {
        if (!hasPicture) {
            notification.error({
                message: _T('competition.status.action.image')
            });
            done();
            return;
        }
        await Api.call(`${CompetitionsSource.url}/${event_id}`, 'publish-results', {})
            .then(() => {
            notification.success({
                message: _T('round.status.published.title')
            });
        })
            .catch((err) => {
            notification.error({
                message: err.message
            });
        });
        done();
    };
    const onOpenGuide = () => {
        updateSettings({
            managerOnboardingGuideStepInfo: `${event_id}/0`
        });
    };
    if (loadingCompetition) {
        return React.createElement(Loading, null);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(HeaderContainer, null,
            React.createElement(Typography, null,
                React.createElement(Title, { key: inputCompetition && inputCompetition.competition_id }, event && event.competition_name),
                eventDateLabel && React.createElement("p", null, eventDateLabel),
                React.createElement("p", null,
                    event && event.competition_location,
                    " - ",
                    (event === null || event === void 0 ? void 0 : event.competition_country) && Localization.getCountryName(event.competition_country))),
            React.createElement(Space, { size: [8, 8], wrap: true },
                createStatusButton(),
                (event === null || event === void 0 ? void 0 : event.competition_level) === 0 &&
                    React.createElement(Link, { to: `/event/${event_id}/competitions`, state: { openGuide: true }, onClick: onOpenGuide },
                        React.createElement(Button, null, _T('onboarding.drawer.open'))),
                needsBilling &&
                    React.createElement(Link, { to: "edit?step=3" },
                        React.createElement(Button, { disabled: (event === null || event === void 0 ? void 0 : event.competition_status) === CompetitionStatus.Archived, icon: React.createElement(CreditCardOutlined, null) }, _T('competition.details.competition_billing_reference.label'))),
                React.createElement(Link, { to: "edit" },
                    React.createElement(Button, { disabled: (event === null || event === void 0 ? void 0 : event.competition_status) === CompetitionStatus.Archived, icon: React.createElement(EditOutlined, null) }, _T('common.edit', { name: _T('competition.event').toLowerCase() }))),
                React.createElement(Button, { onClick: onDelete, danger: true, disabled: !canEdit, icon: React.createElement(DeleteOutlined, null) }, _T('common.delete.title', { name: _T('competition.event').toLowerCase() })))),
        React.createElement(BodyContainer, null,
            React.createElement(Space, { orientation: "vertical", style: { width: '100%' } },
                (event === null || event === void 0 ? void 0 : event.competition_status) === CompetitionStatus.Closed &&
                    React.createElement(ButtonConfirm, { title: _T('round.status.published.action'), description: _T('common.confirm'), onConfirm: done => onPublish(done), buttonProps: {
                            type: 'dashed',
                            size: 'large',
                            icon: React.createElement(GlobalOutlined, null)
                        } }),
                React.createElement(ImageUpload, { value: pictureValue, onChange: onChangePicture, disabled: !canEdit }),
                React.createElement(TextEditor, { value: description, onChange: handleChangeDescription, disabled: !canEdit }),
                React.createElement(Button, { disabled: !hasChanges || !canEdit, onClick: onSaveDescription, icon: React.createElement(SaveOutlined, null) }, _T('common.save'))))));
};
